// This file was automatically generated from ptdata.ptImmunizationDeclines.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.ptImmunizationDeclines');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptImmunizationDeclines.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((soy.$$escapeHtml(opt_data.declinedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.declinedDate)) : ''), '  ', soy.$$escapeHtml(opt_data.cdcType), ' <span class="el8ItalicText">', (opt_data.immunity || opt_data.isImmunity) ? 'Has Immunity' : 'Patient Declined', '</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptImmunizationDeclines.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isImmunity) ? ': Patient has immunity for ' + soy.$$escapeHtml(opt_data.cdcType) + ' immunization' : 'Patient declined ' + soy.$$escapeHtml(opt_data.cdcType) + ' immunization');
  if (!opt_sb) return output.toString();
};
